class Add2Basket {
    constructor(domNode){
        this.domNode = domNode;
        this.button = domNode.querySelector('.button');
        this.message = domNode.querySelector('.sa-message');

        this.dropdownFields = document.querySelectorAll('.product-detail__actions .sa-field--custom-dropdown--js:not(.drop-product-variants)');
        this.quantity = document.querySelector('.product-detail__actions .sa-field--counter--js input');

        this.init();
    }

    init(){
        this.dropdownFields.forEach((field) => {
            field.addEventListener('optionChanged', this.handleActionChange.bind(this), false);
        });

        this.quantity.addEventListener('change', this.handleActionChange.bind(this), false);

        window.addEventListener('load', this.handleActionChange.bind(this), false);
    }

    handleActionChange(e){
        let flag = true;

        this.dropdownFields.forEach((field) => {
            let selection = field.querySelector('button > span');
            if(!selection.dataset.value || selection.dataset.value === "") flag = false;
        });

        if(this.quantity.value == "0") flag = false; 

        if(flag === true){
            this.message.classList.add('is-hidden');
            this.button.classList.remove('is-hidden');
            this.button.removeAttribute('disabled');
        } else{
            this.message.classList.remove('is-hidden');
            this.button.classList.add('is-hidden');
            this.button.setAttribute('disabled', '');
        }
    }
}

exports.Add2Basket = Add2Basket;